var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"pt-4"},[_c('div',{staticClass:"d-flex"},[_c('listarGrupos'),_c('div',{staticClass:"position-relative",staticStyle:{"width":"calc(100vw - 489px)"}},[_c('mapa-geocercas')],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }